// LIBRARIES
import { configureStore, ThunkAction, Action, getDefaultMiddleware } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import { persistReducer, persistStore } from "redux-persist";
import localForage from 'localforage';

// REDUX
import uiReducer from "slices/uiSlice";
import sessionReducer from "slices/sessionSlice";
import supportReducer from "slices/supportSlice";
import lockerReducer from "slices/lockerSlice";
import rentalReducer from "slices/rentalSlice";
import userReducer from "slices/userSlice";
import statisticsReducer from "slices/statisticsSlice";
import auditReducer from "slices/auditSlice";
import paymentsReducer from "slices/paymentsSlice";
import promoCodesReducer from "slices/promoCodesSlice";
import invoicesReducer from "slices/invoicesSlice";
import filtersReducer from "slices/filtersSlice";
// import { persistor } from "index";

export const RESET_STORE = "RESET_STORE";

const persistConfig = {
  key: "root",
  version: 1,
  storage: localForage,
  debounce: 1000,
};

const reducers = combineReducers({
  ui: uiReducer,
  session: sessionReducer,
  support: supportReducer,
  locker: lockerReducer,
  rental: rentalReducer,
  user: userReducer,
  statistics: statisticsReducer,
  audit: auditReducer,
  payments: paymentsReducer,
  invoices: invoicesReducer,
  promoCodes: promoCodesReducer,
  filters: filtersReducer,
});

const rootReducer = (state, action) => {
  if (action.type === RESET_STORE) {
    state = undefined;
  }
  return reducers(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  // devTools: process.env.NODE_ENV !== 'production',
  middleware: getDefaultMiddleware({
    serializableCheck: false
  })
});

export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

// Reset store action
export const resetStore = (): ThunkAction<void, RootState, unknown, Action<string>> => {
  return (dispatch) => {
    dispatch({ type: RESET_STORE });

    setTimeout(() => {
      try {
        persistor.flush()
          .then(() => {
            // Optional: If you want to clear the storage and rehydrate your store:
            return persistor.purge();
          })
          .catch(error => {
            console.error("Error flushing persistor:", error);
            // Optionally, dispatch another action to handle the error if needed
          });
      } catch (error) {
        console.error("Unexpected error:", error);
        // Optionally, dispatch another action to handle the error if needed
      }
    }, 1000);
  };
};
